module.exports = __webpack_public_path__ + "img/01-master_title.ac7119e9.png";